<template>
  <b-card class="device-connection-diagram mb-2" body-class="p-0">
    <header
      slot="header"
      class="d-flex justify-content-between align-items-center device-header"
      @click="$emit('toggle')"
    >
      <div>
        <strong>Endereço {{ paddedAddr }}</strong>
        <span class="text-muted ml-2">{{ device.NAME || device.MODEL_NAME }}</span>
      </div>
      <div class="d-flex align-items-center">
        <span class="badge badge-secondary mr-2">{{ device.MODEL_NAME }}</span>
        <arrow-down-icon class="toggle-icon" :class="{ 'is-expanded': expanded }" />
      </div>
    </header>

    <b-collapse :visible="expanded">
      <div class="p-3">
        <div v-if="device.NOTE" class="device-note mb-3">
          <em>{{ device.NOTE }}</em>
        </div>

        <div v-if="portGroups.length === 0" class="text-muted">
          Nenhuma porta cadastrada nesse modelo.
        </div>

        <div v-for="group in portGroups" :key="group.key" class="port-group mb-3">
          <div class="port-group-label">{{ group.label }}</div>
          <div class="port-group-slots">
            <PortSlotPill v-for="slot in group.slots" :key="slot.position" :slot="slot" />
          </div>
        </div>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import PortSlotPill from "./PortSlotPill.vue";
import { buildDirPortGroups, buildMtdPortGroups } from "../deviceSlots.js";

export default {
  name: "DeviceConnectionDiagram",
  components: { PortSlotPill },
  props: {
    device: {
      type: Object,
      required: true,
    },
    isMtd: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    paddedAddr() {
      return String(this.device.ADDR).padStart(3, "0");
    },
    portGroups() {
      return this.isMtd
        ? buildMtdPortGroups(this.device)
        : buildDirPortGroups(this.device);
    },
  },
};
</script>

<style scoped>
.device-header {
  cursor: pointer;
  margin: -0.75rem -1.25rem;
  padding: 0.75rem 1.25rem;
}

.toggle-icon {
  transition: transform 0.2s ease;
}

.toggle-icon.is-expanded {
  transform: rotate(180deg);
}

.device-note {
  font-size: 0.85em;
  color: var(--text-gray-primary, #666);
  border-left: 3px solid var(--green-3v3, #3d9161);
  padding-left: 8px;
}

.port-group-label {
  font-size: 0.8em;
  text-transform: uppercase;
  color: var(--text-gray-primary, #666);
  margin-bottom: 4px;
}

.port-group-slots {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>
